import axios from "axios";
export default {
    getDocumentGraphData: (documentId) => axios.post("/Documents/GetDocumentGraphData", { documentId }),
    saveDocumentGraphData: (document) => axios.post("/Documents/SaveDocumentGraphData", document),
    getDocumentGraphDataUpdates: (documentId, abortController) => axios.post("/Documents/GetDocumentGraphDataUpdates", { documentId }, { signal: abortController.signal }),
    getSourceTasksResults: (sourceTaskIds) => axios.post("/Documents/GetAndRestoreSourceTasksResults", { sourceTaskIds }),
    getGraphGroupsNodes: (documentId, groupIdArr) => axios.post("Documents/GetDocumentObjectsByGroup", { documentId, groupIdArr }),
    pasteDocumentGraphData: (data) => axios.post("Documents/PasteDocumentGraphData", data)
};
